import { formatPhoneNumberIntl } from 'react-phone-number-input';

export function formatPhoneForDisplay(value) {
  if (!value) return '';
  return formatPhoneNumberIntl(value) || value;
}